module.exports = __webpack_public_path__ + "img/orange_088.cc65b809.png";